import { AllPriceIncludeVATText } from '../../../../common/order/allPriceIncludeVATText'
import { FactSheet } from '../../../../common/order/factSheetReport'
import { factSheetTypes } from '../../../../common/order/factSheetReport/constants'
import { BlockBusinessCreditReport } from './blockBusinessCreditReport'
import { BlockCurrentPlan } from './blockCurrentPlan'

export const PreviewRight = () => {
  return (
    <>
      <BlockBusinessCreditReport />
      <FactSheet type={factSheetTypes.PREVIEW} />
      <BlockCurrentPlan />
      <AllPriceIncludeVATText />
    </>
  )
}
